import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Layout from './Layout/Layout';
import Home from './pages/Home';
import EstablishmentDetail from './pages/EstablishmentDetail';
import Categories from './pages/Categories';
import Map from './pages/Map';
import NotFound from './pages/NotFound';
import Contact from './pages/Contact';
import About from './pages/About';
import Auth from './pages/Auth';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import ProfileSettings from './pages/ProfileSettings';
import ProfileFavorites from './pages/ProfileFavorites';
import Filter from './pages/Filter';
import LegalPage from './pages/LegalPage';
import EventDetail from './pages/EventDetail';
import Events from './pages/Events';
import AppDownload from './pages/AppDownload';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/spot/:id" element={<EstablishmentDetail />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/carte" element={<Map />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/les-spots" element={<Filter />} />
            <Route path="/evenements" element={<Events />} />
            <Route path="/page/:slug" element={<LegalPage />} />
            <Route path="/evenement/:id" element={<EventDetail />} />
            <Route path="/app" element={<AppDownload />} />

            <Route path="/connexion-inscription" element={
              <PublicRoute>
                <Auth />
              </PublicRoute>
            } />

            {/* Protected Routes */}
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/profile/settings" element={
              <ProtectedRoute>
                <ProfileSettings />
              </ProtectedRoute>
            } />
            <Route path="/profile/favorites" element={
              <ProtectedRoute>
                <ProfileFavorites />
              </ProtectedRoute>
            } />

            {/* 404 route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
};

export default App;